module.exports = __webpack_public_path__ + "static/media/users.24bd08a0.svg";